module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"copy":"Скопировать ссылку","share":"Поделиться ссылкой","linkCopied":"Ссылка скопирована","shareDescription":"Посмотри эту подборку вакансий в компании {companyName}","shareTitle":"Подборка вакансий компании {companyName}"}}')
  delete Component.options._Ctor
}
